import { createSlice } from '@reduxjs/toolkit';
import api from '../../api';

const initialState = {
  newMessagesCount: 0,
  loading: false,
  error: null
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    // Fetch new messages count
    fetchNewMessagesCountStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchNewMessagesCountSuccess: (state, action) => {
      state.newMessagesCount = action.payload;
      state.loading = false;
    },
    fetchNewMessagesCountError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Update count from socket
    updateNewMessagesCount: (state, action) => {
      state.newMessagesCount = action.payload;
    },
    // Reset count
    resetNewMessagesCount: (state) => {
      state.newMessagesCount = 0;
    }
  }
});

export const notificationsActions = notificationsSlice.actions;
export default notificationsSlice.reducer;

// Thunk for fetching new messages count
export const fetchNewMessagesCountAction = () => async (dispatch) => {
  dispatch(notificationsActions.fetchNewMessagesCountStart());
  try {
    const res = await api.get('api/Company/new-messages-count');
    if (res.status === 200 && res?.data?.data !== undefined) {
      dispatch(
        notificationsActions.fetchNewMessagesCountSuccess(res.data.data)
      );
      return Promise.resolve(res.data.data);
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error.message;
    dispatch(notificationsActions.fetchNewMessagesCountError(errorMessage));
    return Promise.reject(error);
  }
};
